import { PasswordCharacterSet } from 'src/generated/apollo'
import { useIntl } from '@frontend/t7nd'

export const charset: Record<string, string> = {
  UPPERCASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  LOWERCASE: 'abcdefghijklmnopqrstuvwxyz',
  NUMBER: '0123456789',
  SYMBOLS: '~!@#$%^&*()_+-=,.',
}

export const PasswordCharacterSetMap: (args: {
  formatMessage: ReturnType<typeof useIntl>['formatMessage']
}) => Record<PasswordCharacterSet, string> = ({ formatMessage }) => ({
  UPPERCASE: formatMessage({
    id: '英文大写',
    defaultMessage: '英文大写',
  }),
  LOWERCASE: formatMessage({
    id: '英文小写',
    defaultMessage: '英文小写',
  }),
  NUMBER: formatMessage({
    id: '数字',
    defaultMessage: '数字',
  }),
  SYMBOLS: formatMessage({
    id: '特殊符号',
    defaultMessage: '特殊符号',
  }),
})

export const AuthErrorDict: (args: {
  formatMessage: ReturnType<typeof useIntl>['formatMessage']
}) => Record<string, string> = ({ formatMessage }) => ({
  TENANT_STATE_CHANGED: formatMessage({
    id: '该企业已被禁用，无法登录系统！',
    defaultMessage: '该企业已被禁用，无法登录系统！',
  }),
  ACCOUNT_AUTHORIZATION_CHANGED: formatMessage({
    id: '当前账号的权限发生了变更，为不影响正常操作，请重新登录！',
    defaultMessage: '当前账号的权限发生了变更，为不影响正常操作，请重新登录！',
  }),
  ACCOUNT_INACTIVE: formatMessage({
    id: '当前账号已被禁止登录，无法进行任何操作！',
    defaultMessage: '当前账号已被禁止登录，无法进行任何操作！',
  }),
  ACCOUNT_STATE_CHANGED: formatMessage({
    id: '当前账号身份认证信息被更新，请重新登录！',
    defaultMessage: '当前账号身份认证信息被更新，请重新登录！',
  }),
})
